import React, { useState } from "react";

const Analysisgraph = ({
  color = "#009688",
  label = "Performance",
  performanceData = 0,
}) => {
  const [progress, setProgress] = useState(0);
  const formattedPerformance = performanceData.toFixed(1);

  return (
    <div
      className="p-4 "
      onMouseEnter={() => setProgress(performanceData)}
      onMouseLeave={() => setProgress(0)}
    >
      {/* Progress Bar */}
      <div className="mb-4">
        <div className="flex justify-between items-center mb-1">
          <span className="text-sm font-medium text-gray-700">{label}</span>
          <span className="text-sm font-medium text-[#f8538d]">{formattedPerformance}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div
            className="h-2.5 rounded-full transition-all duration-700 ease-in-out"
            style={{
              width: `${progress}%`,
              backgroundColor: color,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Analysisgraph;
